import { Divider, List, Stack } from '@mui/material';
import { CityOption } from './CityOption';

const MAX_RESULT_VIEW_BEFORE_SCROLL = 4;

interface ICustomCitiesResult {
  selectedCities: string[];
  selectCity: Function;
}

export const CustomCitiesResult = ({
  selectedCities,
  selectCity,
}: ICustomCitiesResult) => {
  return (
    <Stack>
      <List
        sx={{
          padding: 0,
          ...(selectedCities.length > MAX_RESULT_VIEW_BEFORE_SCROLL
            ? {
                overflowY: 'auto',
                maxHeight: '150px',
                overscrollBehavior: 'contain',
              }
            : {}),
        }}
        role='listbox'
      >
        {selectedCities.map((city: string, index: number) => {
          return (
            <CityOption
              key={index}
              option={city}
              isSelected={true}
              selectCity={() => selectCity(city)}
            />
          );
        })}
      </List>
      {selectedCities.length > 0 && (
        <Divider
          orientation='vertical'
          sx={{
            m: '16px 0',
            bgcolor: 'purple2.shade_300',
            width: '100%',
            height: '1px',
          }}
          aria-hidden={true}
        />
      )}
    </Stack>
  );
};
